import { LocalStorageService } from 's2s-app-service';
// import AppService from 's2s-app-service';
import LoggingService from 's2s-logging-service';

import * as ac from './index';

const doFocus = (hasFocus, details) =>{
  const payload = {};

  if (details.hasOwnProperty('uuid')){
    // child window
    payload[details.uuid] = hasFocus;
  } else {
    //main window
    payload['main'] = hasFocus;
  }
  return {
    type: 'SET_FOCUS',
    payload
  };
};
const doClosedTearoff = (data) =>{
  return {
    "type": "CLOSED_TEAROFF",
    "payload": data
  };
};

/*
  REDUNDENT CODE / TODO Determine what to do with this
*/
const doAppStatus = (data) =>{
  return {
    "type": "APP_STATUS",
    "payload": data,
    "meta": {
      "analytics":{
        'category':'main',
        'action': 'status'
      }
    }
  };
};


const doSetOnBoardingSeen = (data) =>{
  return {
    "type": "SETTING_ON_BOARDING",
    "payload": {"value": data},
    "meta": {
      "analytics":{
        'category':'main',
        'action': 'settingOnBoarding'
      }
    }
  };
};

const doAppInitialize = (history) => {
  return (dispatch, getState) => {
    const store = getState();

    if (localStorage && localStorage.credentials) {
      // if credentials is in localStorage, and remember is true, do the login
      const { email, pwd, remember, encrypted } = LocalStorageService.getData('credentials').data;
      //LoggingService.getInstance().debug('-----', email, pwd);
      // only do login if remember is true or if we are in tearaway window.
      // TODO - is it secure to login and go to route just because 'tearaway' is in location.href?? Is
      // there a better way to determine whether or not to continue?
      if (remember || location.href.indexOf('tearaway') > -1){
        // put timeout to allow ws connection to be established
        setTimeout(()=>{
          dispatch(ac.doSubmitLogin(email, pwd, remember, encrypted, history));
        }, 1000);
      }
    }
  };
};

const doSetUserMenuOpen = (data) => {
  LoggingService.getInstance().debug("AC doSetUserMenuOpen", data);
    return {
      type: 'SET_USER_MENU_OPEN',
      payload: data
    };
  };

  // Toggling between Contacts route and other routes.
  const doToggleContactRoute = (route, history) => {
    return (dispatch, getState) => {
      const store = getState();
      //console.log('route, history', route, history);
      // Either go to contactlist route or back to previous route...
      switch (route) {
        case 'contactlist':
          history.push('/appmain/'+ route);
          break;
        default:
          // if currentContact is set, clear it here
          if (store.app.currentContact) {
            dispatch({
              'type': 'SET_CURRENT_CONTACT',
              'payload': {'contactUuid': undefined}
            });
          }
          history.goBack();
      }
    };

  };


export { doClosedTearoff, doAppStatus, doAppInitialize, doFocus, doSetOnBoardingSeen, doSetUserMenuOpen, doToggleContactRoute };



// WEBPACK FOOTER //
// ./src/action-creators/app.js